import { BeneficiarioAPI } from '@/api/beneficiario.api';
import { VUE_APP_NAME } from '@/commons/config';
import { Acampanhamento } from '@/models/acompanhamento';
import { Beneficiario } from '@/models/beneficiario';
import { router } from '@/router';
import BeneficiarioStore from '@/store/modules/beneficiario';
import GlobalStore from '@/store/modules/global';
import JwtDecode from 'jwt-decode';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import BeneficiarioService from './beneficiario.service';
import { Processo } from '@/models/processo';
import { ExpireJwtDecode } from './transportadora.auth.service';
import CryptoJS from 'crypto-js';

export interface BeneficiarioJwtDecode {
  sub: number;
  nome: string;
  numeroDocumento: string;
  dataEmissaoDocumento: string;
  orgaoEmissorDocumento: string;
  ufDocumento: string;
  sexo: string;
  dataNascimento: string;
  cpf: string;
  dddTelefone: string;
  telefone: string;
  logradouro: string;
  numeroLogradouro: string;
  bairro: string;
  municipio: string;
  cep: string;
  nomeMae: string;
  acompanhante: boolean;
  processos: Processo[];
  email: string;
}

class BeneficiarioAuthService {
  private readonly AUTH: string = `${VUE_APP_NAME}-beneficiario-auth`;
  private readonly CPF_NASCIMENTO_STORE: string = `${VUE_APP_NAME}-cpf-nascimento`;
  private readonly beneficiarioApi = new BeneficiarioAPI();

  private readonly SECRET_KEY: string = 'SP$C&NTRALSERVIC0S@RCE2025';

  private beneficiarioSubject = new BehaviorSubject(this.currentBeneficiario());
  private cpfNascimentoSubject = new BehaviorSubject(this.currentCpfNascimento());

  router = router;

  constructor() {
    this.observableChangeCpfNascimento();
    this.observableChangeBeneficiario();
  }

  private encrypt(data: any): string {
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.SECRET_KEY).toString();
  }

  private decrypt(encryptedData: string): any {
    if (!encryptedData) {
      return 0; // Retorna 0 se não houver dados, indicando token expirado
    }
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, this.SECRET_KEY);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedData;
    } catch (error) {
      console.error('Erro ao descriptografar dados:', error);
      return null;
    }
  }
  public currentBeneficiarioValue(): Beneficiario {
    return this.beneficiarioSubject.value;
  }

  public currentCpfNascimentoValue() {
    return this.cpfNascimentoSubject.value;
  }

  public currentCpfNascimento() {
    const cpfNascimento = JSON.parse(localStorage.getItem(this.CPF_NASCIMENTO_STORE)) || null;

    if (!cpfNascimento) return null;

    return cpfNascimento;
  }

  public login(cpf: string, dataNascimento: string, recaptcha: string): Observable<Beneficiario> {
    return this.beneficiarioApi
      .login(cpf, dataNascimento, recaptcha)
      .pipe(map(response => this.setSession(response, cpf, dataNascimento)));
  }

  public searchUser(cpf: string, dataNascimento: string, recaptcha: string): Observable<any> {
    return this.beneficiarioApi.login(cpf, dataNascimento, recaptcha);
  }

  public logout(type?: string, message?: string) {
    localStorage.removeItem(this.CPF_NASCIMENTO_STORE);
    localStorage.removeItem(this.AUTH);

    this.beneficiarioSubject.next(null);

    GlobalStore.setSnackBar({
      show: true,
      message: message || 'Saiu com sucesso!.',
      type: type || 'success',
    });

    router.push({ name: 'passe-livre' });
  }

  public setSession(authResult: any, cpf: string, nascimento: string): any {
    if (authResult) {
      this.buildAuth(authResult);
      this.beneficiarioSubject.next(this.currentBeneficiario());

      if (
        !['passe-livre-edit-cadastro', 'passe-livre-edit-confirmar'].includes(
          String(router.currentRoute.name)
        )
      ) {
        const targetRoute = {
          name: 'passe-livre-detalhe',
          params: { id: String(this.beneficiarioSubject.value.id) },
        };

        // Só navega se não estiver na rota de destino
        if (
          router.currentRoute.name !== targetRoute.name ||
          router.currentRoute.params.id !== targetRoute.params.id
        ) {
          router.push(targetRoute).catch(err => {
            // Ignora silenciosamente erros de navegação duplicada
            if (err.name !== 'NavigationDuplicated') {
              throw err;
            }
          });
        }
      }

      GlobalStore.setSnackBar({
        show: true,
        message: 'Login feito com sucesso.',
        type: 'success',
      });

      return this.beneficiarioSubject.value;
    } else {
      this.buildCpfNascimento({ cpf: cpf, nascimento: nascimento });

      this.cpfNascimentoSubject.next(this.currentCpfNascimento());

      router.push({ name: 'passe-livre-cadastro' });

      return this.cpfNascimentoSubject.value;
    }
  }

  public async setSessionFromRegister(authResult: any) {
    if (authResult) {
      // const { processo } = this.$route.params
      this.buildAuth(authResult);

      console.log(router);
      this.beneficiarioSubject.next(this.currentBeneficiario());

      // const processos = await BeneficiarioService.beneficiarioProcessos(
      //   this.beneficiarioSubject.value.id
      // ).toPromise();

      console.log('AQQQQQQQQQQQQQQQQQQQQQQQQQQQQ', authResult);

      router.push({
        name: 'passe-livre-confirmar-cadastro',
        params: {
          id: String(this.beneficiarioSubject.value.id),
          processo: authResult.processos[0].id,
        },
      });

      return this.beneficiarioSubject.value;
    }
  }

  public hasFinishedRegister(processo: { acompanhamentos: Acampanhamento[] }): boolean {
    const hasFinish = processo.acompanhamentos.map((acomp: any) => Number(acomp.situacaoId) === 2);
    // retorna true Cadastro Estiver Finalizado
    return hasFinish.includes(true);
  }

  public hasInclusionProcess(processo: any): boolean {
    // retorna true se o tipo de processo for Inclusão
    return (
      Number(processo.situacaoId != undefined ? processo.situacaoId : processo.tipoProcessoId) == 1
    );
  }

  public token(): string {
    const { token = null } = JSON.parse(localStorage.getItem(this.AUTH)) || {};
    return token;
  }

  public expireToken(): number {
    const { startSession = null } = JSON.parse(this.decrypt(localStorage.getItem(this.AUTH))) || {};

    if (!startSession) return null;

    const loginTime = new Date(startSession).getTime();
    const eightHoursInMs = 8 * 60 * 60 * 1000; // 8 horas em milissegundos
    const expirationTime = loginTime + eightHoursInMs;

    return expirationTime;
  }

  public async changeSession(beneficiario: Beneficiario) {
    await this.buildAuth(beneficiario);

    this.beneficiarioSubject.next(this.currentBeneficiario());

    return this.beneficiarioSubject.value;
  }

  private observableChangeCpfNascimento() {
    this.cpfNascimentoSubject.subscribe((data: any) => {
      if (BeneficiarioStore) {
        BeneficiarioStore.setBeneficiarioCpfNascimento(data);
      }
    });
  }

  private observableChangeBeneficiario() {
    this.beneficiarioSubject.subscribe((beneficiario: Beneficiario) => {
      if (BeneficiarioStore) {
        BeneficiarioStore.setBeneficiario(beneficiario);
      }
    });
  }

  private buildAuth = (beneficiario: Beneficiario) => {
    localStorage.setItem(this.AUTH, this.encrypt({ ...beneficiario, startSession: new Date() }));
  };

  private buildCpfNascimento = (data: { cpf: string; nascimento: string }) => {
    localStorage.setItem(this.CPF_NASCIMENTO_STORE, JSON.stringify(data));
  };

  private currentBeneficiario(): Beneficiario {
    const encryptedData = localStorage.getItem(this.AUTH);
    if (!encryptedData) return null;
    const {
      id,
      nome,
      numeroDocumento,
      dataEmissaoDocumento,
      orgaoEmissorDocumento,
      ufDocumento,
      sexoId,
      dataNascimento,
      cpf,
      dddTelefone,
      telefone,
      logradouro,
      numeroLogradouro,
      bairro,
      municipio,
      cep,
      nomeMae,
      acompanhante,
      processos,
      email,
      telefones,
      dddTelefone2,
      telefone2,
      complemento,
      municipioDesc,
    } = JSON.parse(this.decrypt(encryptedData)) || {};
    // if (!token) return null;

    // const {
    //   sub,
    //   nome,
    //   numeroDocumento,
    //   dataEmissaoDocumento,
    //   orgaoEmissorDocumento,
    //   ufDocumento,
    //   sexo,
    //   dataNascimento,
    //   cpf,
    //   dddTelefone,
    //   telefone,
    //   logradouro,
    //   numeroLogradouro,
    //   bairro,
    //   municipio,
    //   cep,
    //   nomeMae,
    //   acompanhante,
    //   processos,
    //   email,
    // } = JwtDecode<BeneficiarioJwtDecode>(token);

    const beneficiarioAtual = new Beneficiario(
      id,
      nome,
      numeroDocumento,
      dataEmissaoDocumento,
      orgaoEmissorDocumento,
      ufDocumento,
      sexoId,
      dataNascimento,
      cpf,
      numeroDocumento,
      dddTelefone,
      telefone,
      logradouro,
      numeroLogradouro,
      bairro,
      municipioDesc,
      cep,
      nomeMae,
      acompanhante,
      processos,
      '',
      email,
      telefones,
      dddTelefone2,
      telefone2,
      complemento
    );

    beneficiarioAtual.municipioIbge = municipio?.ibge ?? null;

    return beneficiarioAtual;
  }
}

export default new BeneficiarioAuthService();
